import { type ServiceMethod } from '@/application/interfaces/service';

type Params = {
  cartId: string;
  coupon: string;
};

export type Response = {};

const deleteCoupons: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { cartId, coupon } = data;

    const { body: response } = await httpClient.delete<Response, Params>(
      '/api/v3/carts/{cartId}/coupons/{coupon}',
      {
        ...options,
        params: { cartId, coupon },
      }
    );

    return response;
  };

export default deleteCoupons;
